import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './signUp.module.css';
import InputField from '../../components/containers/inputField/inputField';
import * as actions from "../../store/actions/index";
import PromptMessage from '../../components/containers/promptMessage/promptMessage';
import {sixYardAxios} from "../../sixYardAxios";
import qs from "qs";

const translations = {
  notMember: {
    en: 'Not a member yet?',
    ar: 'لست عضواً بعد؟'
  },
  whyCreate: {
    en: 'Why to create an account?',
    ar: 'لماذا تنشئ حساباً؟'
  },
  rewardText: {
    en: 'To get rewarded with loyalty program and track all your activities with us',
    ar: 'للحصول على مكافآت من برنامج الولاء وتتبع جميع أنشطتك معنا'
  },
  signUp: {
    en: 'SIGN UP',
    ar: 'تسجيل'
  },
  createAccount: {
    en: 'CREATE ACCOUNT',
    ar: 'إنشاء حساب'
  },
  verifyEmail: {
    en: 'VERIFY EMAIL',
    ar: 'تحقق من البريد الإلكتروني'
  },
  oneTimePassword: {
    en: 'One Time Password',
    ar: 'رمز التحقق'
  },
  enterOTP: {
    en: 'Enter the OTP you received by your email to proceed',
    ar: 'أدخل رمز التحقق الذي تلقيته عبر بريدك الإلكتروني للمتابعة'
  },
  alreadyHaveAccount: {
    en: 'Already have an account?',
    ar: 'لديك حساب بالفعل؟'
  },
  login: {
    en: 'Login',
    ar: 'دخول'
  },
  privacyText: {
    en: 'By signing up you agree to our',
    ar: 'بالتسجيل أنت توافق على'
  },
  privacyPolicy: {
    en: 'Privacy Policy',
    ar: 'سياسة الخصوصية'
  },
  and: {
    en: 'and',
    ar: 'و'
  },
  terms: {
    en: 'Terms',
    ar: 'الشروط'
  },
  email: {
    en: 'Email',
    ar: 'البريد الإلكتروني'
  },
  password: {
    en: 'Password',
    ar: 'كلمة المرور'
  },
  enterEmail: {
    en: 'Enter email',
    ar: 'أدخل البريد الإلكتروني'
  },
  enterPassword: {
    en: 'Enter password',
    ar: 'أدخل كلمة المرور'
  }
};

const SignUp = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSignUpClicked, setIsSignUpClicked] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);
  const [error, setError] = useState(false);
  const [isAccountCreatedSuccessfully, setIsAccountCreatedSuccessfully] = useState(false);
  const [fromLogin, setFromLogin] = useState(false);
  const [prefilledEmail, setPrefilledEmail] = useState('');
  const [messageShown, setMessageShown] = useState(false);
  const [controls, setControls] = useState({
    email: {
      elementType: "input",
      elementConfig: {
        type: "email",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterEmail.en : translations.enterEmail.ar,
      },
      value: "",
      label: parseInt(localStorage.getItem('language')) === 1 ? translations.email.en : translations.email.ar,
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false
    },
    password: {
      elementType: "input",
      elementConfig: {
        type: "password",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterPassword.en : translations.enterPassword.ar,
      },
      value: "",
      validation: {
        required: true,
        minLength: 6,
        maxLength: 32,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? translations.password.en : translations.password.ar,
      valid: false,
      touched: false
    }
  });
  const [otpControls, setOtpControls] = useState({
    OTP: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Enter OTP",
      },
      value: "",
      label: "OTP",
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false
    },
  })
  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const otpFormElementsArray = [];
  for (let key in otpControls) {
    otpFormElementsArray.push({
      id: key,
      config: otpControls[key]
    });
  }
  const otpForm = otpFormElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        label={formElement.config.label}
        changed={event => otpInputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const checkValidity = ((value, rules) => {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      value = typeof value === 'string' ? value.trim() : value;
      isValid = value !== "" && isValid;
    }

    if (rules.minLength) {
      isValid = value?.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value?.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
      const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
      isValid = pattern.test(value) && isValid;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  })
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = {
      ...controls,
      [controlName]: {
        ...controls[controlName],
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          controls[controlName].validation
        ),
        touched: true
      }
    };
    setControls(updatedControls);
  };
  const otpInputChangedHandler = (event, controlName) => {
    const updatedControls = {
      ...otpControls,
      [controlName]: {
        ...otpControls[controlName],
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          otpControls[controlName].validation
        ),
        touched: true
      }
    };
    setOtpControls(updatedControls);
  };
  useEffect(()=>{
    // Clear any existing messages
    props.onClearError();
    props.onClearMessage();
    
    // Check if we've already shown the verification message
    const verificationMessageShown = localStorage.getItem('verificationMessageShown');
    if (verificationMessageShown === 'true') {
      setMessageShown(true);
    }
    
    return () => {
      props.onClearError();
      props.onClearMessage();
    }
  },[]);
  useEffect(() => {
    setTimeout(() => {
      if (isAccountCreatedSuccessfully) {
        // Clear any error/success messages
        props.onClearError();
        props.onClearMessage();
        
        // Ensure the verification message flag is set
        localStorage.setItem('verificationMessageShown', 'true');
        
        // Redirect based on whether user came from login or registration
        if (fromLogin) {
          navigate('/', { state: { from: '/login', verified: true } });
        } else {
          navigate('/', { state: { from: '/register' } });
        }
      }
    }, 1000);
  }, [isAccountCreatedSuccessfully]);

  useEffect(() => {
    if (props.user && props.user.requires_verification) {
      setIsSignUpClicked(true);
    }
    else if (props.isAuthenticated) {
      setIsSignUpClicked(true);
    }
  }, [props.isAuthenticated, props.user]);
  
  useEffect(() => {
    if (location.state?.fromLogin && location.state?.email) {
      setFromLogin(true);
      setPrefilledEmail(location.state.email);
      if (location.state.showOTP) {
        setIsSignUpClicked(true);
      }
      
      setControls(prevControls => ({
        ...prevControls,
        email: {
          ...prevControls.email,
          value: location.state.email,
          valid: true,
          touched: true
        }
      }));
    }
  }, [location.state]);

  useEffect(() => {
    if (props.message && props.message.includes("verified successfully") && !messageShown) {
      localStorage.setItem('verificationMessageShown', 'true');
      setMessageShown(true);
      
      const timer = setTimeout(() => {
        props.onClearMessage();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [props.message, messageShown]);

  const signUpSubmitHandler = e => {
    setShowPrompt(true);
    e.preventDefault();
    controls.email.value && controls.password.value && props.onRegister(
      controls.email.value,
      controls.password.value,
    );
    
  };
  const OTPSubmitHandler = e => {
    setShowPrompt(true);
    e.preventDefault();
    
    const verificationEndpoint = fromLogin ? "/auth/verify-otp" : "/auth/verify-otp";
    
    sixYardAxios
      .post(
        verificationEndpoint,
        JSON.stringify({
          email: controls.email.value,
          otp: otpControls.OTP.value,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      )
      .then(res => {
        const user = res.data.data.user;
        const token = res.data.data.token;
        
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        
        // Mark that the verification message will be shown now
        // We'll set it to false and then to true after showing the message once
        localStorage.setItem('verificationMessageShown', 'false');
        
        props.onAuthSuccess({token: token}, user, res.data.message);
        
        setIsAccountCreatedSuccessfully(true);
      })
      .catch(err => {
        setError(err.response?.data?.message || "Failed to verify OTP");
      });
  };

  const Header = (props) => {
    return (
      <div>
        <h1>{props.h1}</h1>
        <p className={classes.Description}>
          {props.span && <span>{props.span}</span>}
          {props.p}
        </p>
        {props.h2 && <h2>{props.h2}</h2>}
      </div>
    )
  }

  const Form = (props) => {
    return (
      <form className={classes.Form} onSubmit={(e) => props.onSubmit(e)}>
        {props.input.map((item, i) =>
          <InputField label={item.label}
            type={item.type}
            placeholder={item.placeholder}
            required={item.required}
            inputMode={item.inputMode}
            pattern={item.pattern}
            changed={item.changed}
          />
        )}
        <button type="submit"
          className={classes.Button}
          onClick={() => {
            if (props.button === 'SIGN UP') setIsSignUpClicked(true)
            if (props.button === 'CREATE ACCOUNT') setIsAccountCreatedSuccessfully(true)
          }}>
          {props.button}
        </button>
      </form>
    )
  }

  const handleCloseVerificationMessage = () => {
    setShowPrompt(false);
    props.onClearMessage();
    localStorage.setItem('verificationMessageShown', 'true');
    setMessageShown(true);
  };

  return (
    <div className={classes.Container}>
      {!isSignUpClicked ? 
        <Header 
          h1={parseInt(localStorage.getItem('language')) === 1 ? translations.notMember.en : translations.notMember.ar}
          span={parseInt(localStorage.getItem('language')) === 1 ? translations.whyCreate.en : translations.whyCreate.ar}
          p={parseInt(localStorage.getItem('language')) === 1 ? translations.rewardText.en : translations.rewardText.ar}
          h2={parseInt(localStorage.getItem('language')) === 1 ? translations.signUp.en : translations.signUp.ar}
        /> :
        <Header 
          h1={parseInt(localStorage.getItem('language')) === 1 ? translations.oneTimePassword.en : translations.oneTimePassword.ar}
          p={parseInt(localStorage.getItem('language')) === 1 ? 
            (fromLogin ? "Please verify your email to continue with your account" : translations.enterOTP.en) : 
            (fromLogin ? "يرجى التحقق من بريدك الإلكتروني للمتابعة مع حسابك" : translations.enterOTP.ar)}
        />
      }
      <div className={classes.FormLayout}>
        {!isSignUpClicked ? 
          <form className={classes.Form} onSubmit={(e) => signUpSubmitHandler(e)}>
            {form}
            <button type="submit" className={classes.Button}>
              {parseInt(localStorage.getItem('language')) === 1 ? translations.signUp.en : translations.signUp.ar}
            </button>
          </form>
          : 
          <form className={classes.Form} onSubmit={(e) => OTPSubmitHandler(e)}>
            {otpForm}
            <button type="submit" className={classes.Button}>
              {parseInt(localStorage.getItem('language')) === 1 ? 
                (fromLogin ? translations.verifyEmail.en : translations.createAccount.en) : 
                (fromLogin ? translations.verifyEmail.ar : translations.createAccount.ar)}
            </button>
          </form>
        }
        <p className={classes.Prompt}>
          {parseInt(localStorage.getItem('language')) === 1 ? translations.alreadyHaveAccount.en : translations.alreadyHaveAccount.ar} 
          <a href="/login" className={classes.Link}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}
          </a>
        </p>
        <p className={classes.Prompt}>
          {parseInt(localStorage.getItem('language')) === 1 ? translations.privacyText.en : translations.privacyText.ar} 
          <a href="/privacy-policy" target='_blank' className={classes.Link}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.privacyPolicy.en : translations.privacyPolicy.ar}
          </a> {parseInt(localStorage.getItem('language')) === 1 ? translations.and.en : translations.and.ar} 
          <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.terms.en : translations.terms.ar}
          </a>
        </p>
      </div>
      {props.message && showPrompt && !messageShown && 
        <PromptMessage 
          message={props.message} 
          status='SUCCESS' 
          button='CLOSE' 
          click={handleCloseVerificationMessage} 
          successMessage
        />
      }
      {props.error && showPrompt && 
        <PromptMessage 
          message={props.error.message?.['password'] ? props.error.message?.['password'] : props.error.message?.['email'] || props.error.message} 
          status='ERROR' 
          button='OK' 
          click={()=>setShowPrompt(false)}
        />
      }
      {error && showPrompt && 
        <PromptMessage 
          message={error} 
          status='ERROR' 
          button='OK' 
          click={()=>setError(false)}
        />
      }
    </div>
  )
}
const mapStateToProps = state => ({
  isAuthenticated: state.auth.token !== null,
  message: state.auth.message,
  error: state.auth.error,
  user:state.auth.user,
});
const mapDispatchToProps = dispatch => {
  return {
    onRegister: (email, password) => dispatch(actions.register(email, password)),
    onClearError: () => dispatch(actions.clearError()),
    onAuthSuccess: (token, user, message) => dispatch(actions.authSuccess(token, user, message)),
    onClearMessage: () => dispatch(actions.clearMessage()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignUp);